import { mockSuccess, listPayload } from './shared';
import type { MockRouteEntry } from '../mock-api.types';

const ROWS = [
    { id: 'mock-1', title: 'April 2026 — Main branch', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
    { id: 'mock-2', title: 'March 2026 — Main branch', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
    { id: 'mock-3', title: 'February 2026 — Main branch', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
];

export const PAYROLL_MOCK_HANDLERS: MockRouteEntry[] = [
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/payroll\/runs(\?|$)/i,
        handler: () => mockSuccess(listPayload(ROWS)),
    },
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/payroll\/runs\/([^/?]+)/i,
        handler: (req) => {
            const match = req.url.match(/\/runs\/([^/?]+)/i);
            const id = match ? match[1] : '';
            const row = ROWS.find((r) => r.id === id) ?? ROWS[0];
            return mockSuccess(row);
        },
    },
];
